module.exports = __webpack_public_path__ + "sn.38f49251023013aa94ad.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sn.svg
// module chunks = styles